<div class="container-fluid p-3">
    <div class="col-md-12 my-3">
        <div class="row">
            <div class="col-md-5">
                <h5 class="user_name title-head">{{employeeDetail?.firstname}} {{employeeDetail?.lastname}}
                     ({{employeeDetail?.employeecode}})</h5>
                <p class="designation">{{attendanceData[0]?.employee?.Designation?.name}}</p>
            </div>

            <div class="col-md-3 text-end">
                <!-- <select class="form-select" class="view_type">
                    <option value="" class="bg-white">Attendance View</option>
                    <option value="">Table View</option>
                </select> -->
            </div>
            <div class="col-md-3 text-end">
                <!-- <select class="form-select" class="reqularized">
                    <option value="" class="bg-white text-dark">Attendance Reqularization</option>
                    <option value="" class="bg-white text-dark">Att</option>
                </select> -->
            </div>
            <div class="col-md-1">
                <button class="btn attendance-calendar m-0" (click)="goToBack()">List View</button>
            </div>
        </div>
    </div>

    <div class="col-md-12 my-3">
        <div class="calendar_month">
            <div class="d-flex align-items-center">
                <span class="pe-2 designation">Attendance for</span>
                <p-calendar [(ngModel)]="date" view="month" touchUI="true" dateFormat="mm/yy" [readonlyInput]="true"
                    (onSelect)="changeCalendar($event)" />
            </div>
            <!-- <div class="d-flex align-items-center">
                <span class="mx-2 designation">Working Hours</span>
                <i class="fa-solid fa-grip-lines-vertical mx-3"></i>
                <p class="m-0 designation">Actual : 36 hh 52 mm</p>
            </div> -->
        </div>
    </div>

    <div class="calendar my-3">
        <div id="calendar"></div>
        <full-calendar #calendar [options]="calendarOptions"
            aria-controls="offcanvasTop"></full-calendar>
    </div>
</div>

<!-- Canvas -->
<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel">
    <div class="offcanvas-header">
        <h5 id="offcanvasTopLabel">View Attendance</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body p-4">
        <div class="flex-auto">
            <p-calendar [dateFormat]="companySettingDate" [(ngModel)]="currentDate" [minDate]="joiningDate" [maxDate]="today" [iconDisplay]="'input'" touchUI="true" [showIcon]="true" inputId="icondisplay"
                (onSelect)="selectDate($event)" />
        </div>
        <div class="py-3">
            <span class="py-3 fs-4 fw-bold">{{selectedDate?.attendancedate | date: angularDateFormat}}</span>
            <span class="present mx-2 py-1 px-2"
                *ngIf="selectedDate?.checkintime && selectedDate?.checkouttime">Present</span>
            <span class="py-4 mx-2 px-2 late_check_in"
                *ngIf="selectedDate?.status == 'Late Check-In'">{{selectedDate?.status}}</span>
            <span class="py-4 mx-2 px-2 leave_approve"
                *ngIf="selectedDate?.status == 'Leave Approved'">{{selectedDate?.status}}</span>
        </div>
        <div class="py-2">
            <p class="working_hour" *ngIf="selectedDate?.totalhoursworked">Working Hours : <span
                    class="working_time">{{selectedDate?.totalhoursworked}}</span>
            </p>
            <p class="working_hour" *ngIf="selectedDate?.shiftStartTime">Shift Details : <span
                    class="working_time">{{selectedDate?.shiftStartTime}} -
                    {{selectedDate?.shiftEndTime}}</span></p>
        </div>
        <div>
            <button type="button" class="btn btn-redirect me-2" [routerLink]="['/app/employee/leave']">
                Apply Leave
            </button>
            <button type="button" class="btn btn-redirect" *ngIf="showButton"
            (click)="regularisationDatePass()">
                Request Regularization
            </button>
        </div>
        <div class="py-2 row">
            <div class="col-md-4" *ngIf="selectedDate?.checkintime">
                <p class="working_hour">In - Time</p>
                <h6 class="working_time">{{selectedDate?.checkintime | date:'shortTime': 'UTC' }}</h6>
            </div>
            <div class="col-md-4" *ngIf="selectedDate?.checkouttime">
                <p class="working_hour">Out - Time</p>
                <h6 class="working_time">{{selectedDate?.checkouttime | date:'shortTime': 'UTC' }}</h6>
            </div>
        </div>
        <hr>
        <div>
            <!-- <div *ngFor="let item of selectedDate?.break">
                <div *ngIf="(item?.breakintime || item?.breakouttime) !== ''">
                    <p class="fw-bold">{{item?.break_name}}</p>
                    <p *ngIf="(item?.breakintime) !== ''">Break In Time : {{item?.breakintime | date
                        :'shortTime' : 'UTC'}}</p>
                    <p *ngIf="(item?.breakouttime) !== ''">Break Out Time : {{item?.breakouttime | date
                        : 'shortTime' :'UTC'}}</p>
                </div>
            </div> -->
        </div>

        <div class="stepper-container">
            <h4>Attendance Times</h4>
            <mat-vertical-stepper [linear]="true" [selectedIndex]="selectedIndex">
                <div *ngFor="let item of selectedDate?.break; let i = index">
                    <mat-step [label]="'Step ' + item.id" [label]="'Step 1'"
                        *ngIf="(item?.breakintime || item?.breakouttime) !== ''">
                        <div class="step-content">
                            <!-- <div matStepLabel class="step-label">{{i+1}}</div> -->
                            <div class="step-text">
                                <p class="fw-bold">{{item?.break_name}}</p>
                                <p *ngIf="(item?.breakintime) !== ''">Break In Time : {{item?.breakintime | date
                                    :'shortTime' : 'UTC'}}</p>
                                <p *ngIf="(item?.breakouttime) !== ''">Break Out Time : {{item?.breakouttime | date
                                    : 'shortTime' :'UTC'}}</p>
                            </div>
                        </div>
                    </mat-step>
                </div>
            </mat-vertical-stepper>
        </div>
    </div>
</div>